import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import Page from "../../components/general/page";

const ENABLED_COMPANIES_FEATURE = process.env.REACT_APP_NEW_DOCS_COMPANIES;
const NEW_DOC_REDIRECT_URL = process.env.REACT_APP_NEW_DOC_REDIRECT_URL;

export function DocumentsVersionChooser({ children, pageRef }) {
  // const auth = useSelector((state) => state.auth);
  // const company = useSelector((state) => state.company);
  const main = useSelector((state) => state.main);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (main.accountantUuidSelected && main.companyUuidSelected) {
      setLoading(false);
      console.log(main.accountantUuidSelected, main.companyUuidSelected);
    }
  }, [main.accountantUuidSelected, main.companyUuidSelected]);

  return (
    !loading && (ENABLED_COMPANIES_FEATURE?.split(",").includes(main.accountantUuidSelected) || ENABLED_COMPANIES_FEATURE === "*") ? (
      <Page pageRef={pageRef} noHeaderContent noClassName>
        <div style={{}}>
          <div style={{ marginTop: 80, marginLeft: 85 }}>
            <iframe
              style={{ border: "none", height: "90vh" }}
              width={"98%"}
              src={
                NEW_DOC_REDIRECT_URL +
                (main.myType === "STUDIO"
                  ? `${encodeURIComponent(`?embed=true&companyId=${main.accountantUuidSelected}&counterpart=${main.companyUuidSelected}`)}`
                  : `${encodeURIComponent(`?embed=true&companyId=${main.companyUuidSelected}&counterpart=${main.accountantUuidSelected}`)}`)
              }
              title={"Documents"}
            />
          </div>
        </div>
      </Page>
    ) : (
      children
    )
  );
}
